export const otherCountryField = () => {
  const countryField = document.querySelector("[data-wm-form-field='country']");
  const postalField = document.querySelector("[data-wm-form-field='postal']");

  if (!countryField || !postalField) {
    return;
  }

  const countrySelect = countryField.querySelector("select");
  const postalFieldInput = postalField.querySelector("input");
  const labels = {
    "other-country": document.querySelector("[data-wm-other-country-label]")
      .innerHTML,
    "postal-code": postalField.querySelector("label").innerHTML,
  };
  const otherCountryError = document.querySelector(
    "[data-wm-other-country-error-required]"
  ).innerHTML;

  let wasPostalFieldModified = false;

  const changePostalFieldInput = (fieldType) => {
    wasPostalFieldModified = fieldType === "other-country";
    postalFieldInput.value = "";
    postalField.querySelector("label").innerHTML = labels[fieldType];
    postalField.classList.remove("is-floating");
    postalField.classList.toggle(
      "is-other-country-field",
      fieldType === "other-country"
    );
  };

  const handleCountryChange = (event) => {
    if (event.target.value.toLowerCase() === "other") {
      changePostalFieldInput("other-country");
    } else if (wasPostalFieldModified) {
      changePostalFieldInput("postal-code");
    }
  };

  const handleAkErrorChanges = (akError) => {
    const hasError = akError[0].target.classList.contains("ak-error");
    postalField.classList.toggle("has-errors", hasError);
  };

  const init = () => {
    if (!countrySelect) {
      return;
    }

    countrySelect.addEventListener("change", handleCountryChange);
    postalField.insertAdjacentHTML("beforeend", otherCountryError);

    const observer = new MutationObserver(handleAkErrorChanges);
    observer.observe(postalField.querySelector("label"), {
      attributes: true,
      attributeFilter: ["class"],
    });
  };

  init();
};
